import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import Vue from "vue";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { Image } from "@/modules/images/viewmodels/Image";

export const state = {
  images: [],
};

export const getters = Object.assign(
  {
    images: (state) => {
      return state.images;
    },
    image: (state) => (Id) => {
      return state.images.find((e) => e.id === Id);
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/images",
    Image,
    {
      AfterGetAll: (name, data) => {
        state.images = data;
        return state.images;
      },
      AfterGet: (name, Images) => {
        Images.data.forEach(img=>{
          let el = state.images.find((e) => e.id === img.id);
          if (el) {
            el = img;
          } else {
            state.images.push(img);
          }
        });
        return Images;
      },
      AfterShow: (name, data) => {
        let el = state.images.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.images.push(data);
        }
        return data;
      },
      AfterCreate: (name, data) => {
        state.images.unshift(data);
        return data;
      },
      AfterDestroy: (name, data) => {
        let elementIndex = state.images.findIndex((e) => e.id === data);

        if (elementIndex !== null) {
          Vue.delete(state.images, elementIndex);
        }
        return data;
      },
    },
    {
      /**
       * ShowObject
       * this.$store.getters['image/api'].Custom.ShowObject()
       */
      ShowObject: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/images/" + Id + "/show-object"
        );

        let data = new Image(ApiResult.data.data);

        return data;
      },
    }
  )
);

// mutations
export const mutations = {};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/images",
  [],
  {}
);
